module.exports = __webpack_public_path__ + "img/OddsGaloreLogoGrey.bf0c179f.png";